import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";

const CancelledMembersStatsPrevious = () => {
  const { prevCancelMembers, prevCancelMembersRawDataLink, tooltip } = useSelector(
    (state) => state.membershipSales.statistics.cancelledMembers
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <SectionContainer
      title="Previous Cancelled Members"
      toolTip={`Previous ${tooltip}`}
      toolTipId="membershipDetailsPreviousCancelledMembers"
    >
      <NumberDisplay
        value={prevCancelMembers}
        url={prevCancelMembersRawDataLink}
        disableAnimation={isUserQa}
        toolTipId="membershipDetailsPreviousCancelledMembers"
        toolTipContent={`Previous ${tooltip}`}
      />
    </SectionContainer>
  );
};

export default CancelledMembersStatsPrevious;
